import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Entity } from 'breeze-client';
import { AddressValidationService } from './address-validation.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-address-component',
  templateUrl: './address.component.html',
  standalone: false
})
export class AddressComponent implements OnInit {
  @ViewChild("nameInput") nameInput: ElementRef<HTMLInputElement>;

  _isReadonly: boolean;
  @Input() entity: Entity;
  @Input() prefix: string;
  @Input() showValidateButton = true;
  @Input()
  set isReadonly(isReadonly: boolean) {
    this._isReadonly = isReadonly;
  }
  get isReadonly() {
    return this._isReadonly;
  }
  validationTitle = "";
  constructor(private validationService: AddressValidationService, private toastr: ToastrService) {
  }

  ngOnInit() {
    if (this.isReadonly == null) {
      this.isReadonly = true;
    }
    this.validationTitle = this.isReadonly ?
      "Validate address using the US Postal Service; show an error if invalid" :
      "Update address using the US Postal Service; show an error if invalid";
  }

  hasField(partialName: string) {
    const ea = this.entity && this.entity.entityAspect;
    if (ea == null) {
      return;
    }
    const propName = this.prefix + partialName;
    return this.entity.entityType.dataProperties.some(dp => dp.name === propName);
  }

  getErrorMessage(partialName: string) {
    if (this.isReadonly) {
      return null;
    }
    const propName = this.prefix + partialName;
    const ea = this.entity && this.entity.entityAspect;
    if (ea == null) {
      return;
    }
    const errors = ea.getValidationErrors(propName);
    if (errors.length === 0) {
      return;
    }
    return errors.map(e => e.errorMessage).join('; ');
  }

  async validate() {
    const msg = await this.validationService.validateEntityAddress(this.entity, this.prefix, !this.isReadonly);
    if (msg) {
      this.toastr.error(msg, "Address Validation Error");
    } else {
      this.toastr.success("Address is valid", "Address Validation");
    }
  }

  focus() {
    this.nameInput?.nativeElement?.focus();
  }
}
